import {useRef, useCallback} from "react";
import {a as useEnhancedEffect} from "./useForkRef-edb3fede.js";
function useEventCallback(fn) {
  const ref = useRef(fn);
  useEnhancedEffect(() => {
    ref.current = fn;
  });
  return useCallback((...args) => (0, ref.current)(...args), []);
}
export {useEventCallback as u};
